import { formatISO } from "date-fns";
import PolicyMixin from "@/mixins/PolicyMixin";
import _ from "lodash";
const MODALITY_STEP = 0;
const COMPANY_STEP = 1;
const INSURED_STEP = 2;
const TYPE_RESOURCE_STEP = 3;
const VALUE_RESOURCE_STEP = 4;
const VALUE_IS = 5;
const STEP_PRODUCT = 0;
const STEP_RISK = 1;
const STEP_INSURED = 2;
const STEP_COSTS = 3;
const STEP_INSURED2 = 5;
const STEP_RISK2 = 6;

export const QuotationMixin = {
  mixins: [PolicyMixin],
  methods: {
    checkCurrentQuotationStep(current, step) {
      // Evitar do usuário entrar nesse rota pela url
      // sem ele ter passado pelos passos anteriores
      if (current < step)
        this.$router.push({ name: "quotation step modality" });
    },
    cancelQuotationButton() {
      this.$router.push({ name: "quotation" });
    },
    payloadQuotation(form, step) {
      return {
        form: form,
        step: step
      };
    },
    dateISO(date) {
      const [day, month, year] = date.split("/");
      let data = new Date(year, month - 1, day);
      return formatISO(data, { representation: "date" });
    },
    getRecursalValue(storeQuotation) {
      return this.optionsQuotation.recursos.obrigatorio
        ? [
            {
              tipo_recurso: storeQuotation[TYPE_RESOURCE_STEP].form.resource,
              valor_deposito_recursal:
                parseFloat(
                  storeQuotation[VALUE_RESOURCE_STEP].form.value.replace(
                    /\D+/g,
                    ""
                  )
                ) / 100
            }
          ]
        : [];
    },
    getProcessQuotation(formDeadline) {
      // Se não tiver tipo do processo, devo passar null, em vez de passar os valores das keys como null
      if (
        !this.optionsQuotation.processo_judiciario.numero_processo.obrigatorio
      ) {
        return null;
      }
      // Cópia para não alterar meu formulário
      let processQuotation = _.cloneDeep(formDeadline);
      // Caso o processo não tiver um tipo, preciso passar o tipo_processo null em vez de apenas o id
      if (
        processQuotation.tipo_processo.id == null ||
        !this.optionsQuotation.processo_judiciario.tipo_processo.obrigatorio
      ) {
        processQuotation.tipo_processo = null;
      }
      // Back-end rejeita cotação caso tenha (nome_tribunal e tribunal)
      // ou (nome_unidade e unidade), então devo verificar qual tipo é utilizado
      // e passar nulo o outro
      if (!this.optionsQuotation.processo_judiciario.tribunal.nome_livre) {
        processQuotation.nome_tribunal = null;
        processQuotation.nome_unidade = null;
      } else {
        processQuotation.tribunal = null;
        processQuotation.unidade = null;
      }
      return processQuotation;
    },
    async getPayloadNewQuotation(storeQuotation, formDeadline) {
      let recursal = this.getRecursalValue(storeQuotation);
      let date_end =
        formDeadline.date_end && this.dateISO(formDeadline.date_end);
      let files = await this.submitFiles(formDeadline.anexos);
      let processQuotation = this.getProcessQuotation(formDeadline);
      const payload = {
        modalidade: storeQuotation[MODALITY_STEP].form.modality,
        submodalidade: storeQuotation[MODALITY_STEP].form.subModality,
        tipo_emissao: storeQuotation[MODALITY_STEP].form.emissionType,
        tomador: storeQuotation[COMPANY_STEP].form.taker,
        segurado: storeQuotation[INSURED_STEP].form,
        recursos: recursal,
        inicio_vigencia: this.dateISO(formDeadline.date),
        fim_vigencia: date_end,
        prazo: formDeadline.prazo,
        processo: processQuotation,
        numero_controle_interno: formDeadline.numberProposal,
        escritorio: formDeadline.escritorio,
        valor_importancia_segurada:
          storeQuotation[VALUE_IS].form.valor_importancia_segurada,
        composicao_importancia_segurada:
          storeQuotation[VALUE_IS].form.composicao_importancia_segurada,
        anexos: files,
        cobertura_adicional: formDeadline.cobertura_adicional,
        informacoes_contrato: formDeadline.informacoes_contrato
      };
      return payload;
    },
    async getPayloadNewQuotationAgro(storeQuotation) {
      let isAgricola =
        storeQuotation[STEP_PRODUCT].form.modality.id == "agricola";

      let isCafezal =
        storeQuotation[STEP_PRODUCT].form.modality.id == "cafezal";

      let items = [];

      if (isAgricola) {
        items = await this.formatItemListAgricola(
          storeQuotation[STEP_RISK].form.agricola.items,
          storeQuotation[STEP_RISK2].form?.areas
        );
      } else if (isCafezal) {
        items = await this.formatItemListCafezal(
          storeQuotation[STEP_RISK].form.cafezal.items,
          storeQuotation[STEP_RISK2].form?.areas
        );
      }

      let segurado = { ...storeQuotation[STEP_INSURED].form };
      segurado.telefone = storeQuotation[STEP_INSURED].form?.phone;

      if (storeQuotation[STEP_INSURED2].form.data_nascimento != null) {
        segurado.endereco = {
          cep: storeQuotation[STEP_INSURED2].form.endereco.cep,
          logradouro: storeQuotation[STEP_INSURED2].form.endereco.logradouro,
          numero: storeQuotation[STEP_INSURED2].form.endereco.numero,
          complemento: storeQuotation[STEP_INSURED2].form.endereco.complemento,
          bairro: storeQuotation[STEP_INSURED2].form.endereco.bairro,
          cidade: storeQuotation[STEP_INSURED2].form.endereco.cidade,
          uf: {
            sigla: storeQuotation[STEP_INSURED2].form.endereco.uf.sigla
          }
        };

        let dadosBancarios = storeQuotation[STEP_INSURED2].form.dados_bancarios;
        if (dadosBancarios.banco?.id != null) {
          segurado.dados_bancarios = {
            banco: {
              id: dadosBancarios.banco.id,
              name: dadosBancarios.banco.nome
            },
            agencia: dadosBancarios.agencia,
            conta: dadosBancarios.conta
          };
        } else {
          segurado.dados_bancarios = null;
        }
        segurado.estado_civil = {
          id: storeQuotation[STEP_INSURED2].form.estado_civil.id,
          name: storeQuotation[STEP_INSURED2].form.estado_civil.nome
        };
        segurado.genero = {
          id: storeQuotation[STEP_INSURED2].form.genero.sigla,
          name: storeQuotation[STEP_INSURED2].form.genero.nome
        };
        segurado.data_nascimento = this.dateISO(
          storeQuotation[STEP_INSURED2].form.data_nascimento
        );
        segurado.numero_documento_extra =
          storeQuotation[STEP_INSURED2].form.numero_documento_extra;
        segurado.data_expedicao = this.dateISO(
          storeQuotation[STEP_INSURED2].form.data_expedicao
        );
        segurado.orgao_expedidor = storeQuotation[STEP_INSURED2].form
          .orgao_expedidor.nome
          ? storeQuotation[STEP_INSURED2].form.orgao_expedidor.nome
          : storeQuotation[STEP_INSURED2].form.orgao_expedidor;
        segurado.tipo_documento = {
          id: storeQuotation[STEP_INSURED2].form.tipo_documento.id,
          name: storeQuotation[STEP_INSURED2].form.tipo_documento.nome
        };
      }

      let creditoRural = {
        is_credito_rural: segurado.credito_rural.is_credito_rural,
        valor_credito_rural: segurado.credito_rural.valor_credito_rural,
        documento_beneficiario: segurado.credito_rural.documento_beneficiario,
        nome_beneficiario: segurado.credito_rural.nome_beneficiario
      };

      const payload = {
        id: storeQuotation[STEP_COSTS].form.numero_cotacao,
        modalidade: storeQuotation[STEP_PRODUCT].form.modality,
        submodalidade: storeQuotation[STEP_PRODUCT].form.subModality,
        grupo_economico_id: storeQuotation[STEP_PRODUCT].form.taker?.id,
        area_risco: storeQuotation[STEP_RISK].form.endereco,
        itens_agricola: isAgricola ? items : [],
        itens_cafezal: isCafezal ? items : [],
        segurado: segurado,
        documento_credito_rural: creditoRural.is_credito_rural
          ? creditoRural.documento_beneficiario
          : null,
        nome_credito_rural: creditoRural.is_credito_rural
          ? creditoRural.nome_beneficiario
          : null,
        valor_credito_rural: creditoRural.is_credito_rural
          ? creditoRural.valor_credito_rural
          : null
      };
      return payload;
    },
    async formatItemListAgricola(items, areas) {
      let result = [];

      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        let files = await this.submitFiles(item.kmlFiles);

        let coordenadas = [];
        let complementoArea = Array.isArray(areas)
          ? areas.find(area => area.id === item.id)
          : null;

        item.coordenadas.forEach(coord => {
          coordenadas.push({
            latitude: coord.latitude.toString(),
            longitude: coord.longitude.toString()
          });
        });

        // Se a esta na tela de risco 2, as coordenadas passam a ser obrigatorias e no minimo sao iguais que a do risco 1
        if (complementoArea && complementoArea?.coordenadas?.length > 0) {
          coordenadas = [];
          complementoArea.coordenadas.forEach(e => {
            coordenadas.push({
              latitude: e.latitude.toString(),
              longitude: e.longitude.toString()
            });
          });
        }

        result.push({
          id: item.id,
          nome: item.nome,
          area_plantada: complementoArea?.plantedArea ?? item.plantedArea,
          tecnica_plantio: item.plantingTechniques.id,
          classificacao_solo: item.soilType,
          data_plantio: this.dateISO(item.plantingDate),
          reivindicar_colheita_atual: item.claimCurrentHarvest,
          plantado: item.alreadyPlanted,
          primeiro_ano_plantio: item.yearsPlanting?.id == '1' || item.yearsPlanting == true ? true : false,
          soja_apos_cana_acucar: item.soyAfterSuggarCane,
          enderecos_coordenadas_kml: files,
          coordenadas: coordenadas,
          // Incluir dados adicionais do STEP_RISK2
          car: complementoArea ? complementoArea.car : null,
          roteiro_acesso: complementoArea?.roteiro_acesso,
          endereco: {
            numero: complementoArea ? complementoArea.numero : null,
            logradouro: complementoArea ? complementoArea.logradouro : null,
            bairro: complementoArea ? complementoArea.bairro : null,
            complemento: complementoArea ? complementoArea.complemento : null,
            cidade: complementoArea ? complementoArea.cidade : null,
            uf: complementoArea ? complementoArea.uf : null,
            cep: complementoArea ? complementoArea.cep : null
          }
        });
      }
      return result;
    },
    async formatItemListCafezal(items, areas) {
      let result = [];

      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        let files = await this.submitFiles(item.kmlFiles);

        let coordenadas = [];
        let complementoArea = Array.isArray(areas)
          ? areas.find(area => area.id === item.id)
          : null;

        item.coordenadas.forEach(coord => {
          coordenadas.push({
            latitude: coord.latitude.toString(),
            longitude: coord.longitude.toString()
          });
        });

        // Se a esta na tela de risco 2, as coordenadas passam a ser obrigatorias e no minimo sao iguais que a do risco 1
        if (complementoArea && complementoArea?.coordenadas?.length > 0) {
          coordenadas = [];
          complementoArea.coordenadas.forEach(e => {
            coordenadas.push({
              latitude: e.latitude.toString(),
              longitude: e.longitude.toString()
            });
          });
        }

        result.push({
          id: item.id,
          nome: item.nome,
          area_plantada: complementoArea?.plantedArea ?? item.areaPlantada,
          especie_cafe: item.especie.id,
          variedade_cafe: item.variedade.id,
          sistema_cultivo_cafe: item.sistemaCultivo.id,
          idade: item.idade,
          espacamento_plantas: item.espacamentoPlantas,
          espacamento_linhas: item.espacamentoLinhas,
          planta_hectare: item.plantasPorHectare,
          data_ultima_recepa:
            item.dataUltimaRecepa != null && item.dataUltimaRecepa != ""
              ? this.dateISO(item.dataUltimaRecepa)
              : null,
          danos_ciclo: item.danosNoCiclo ?? false,
          enderecos_coordenadas_kml: files,
          coordenadas: coordenadas,
          // Incluir dados adicionais do STEP_RISK2
          car: complementoArea ? complementoArea.car : null,
          roteiro_acesso: complementoArea
            ? complementoArea.roteiro_acesso
            : null,
          endereco: {
            numero: complementoArea ? complementoArea.numero : null,
            logradouro: complementoArea ? complementoArea.logradouro : null,
            bairro: complementoArea ? complementoArea.bairro : null,
            complemento: complementoArea ? complementoArea.complemento : null,
            cidade: complementoArea ? complementoArea.cidade : null,
            uf: complementoArea ? complementoArea.uf : null,
            cep: complementoArea ? complementoArea.cep : null
          }
        });
      }

      return result;
    },
    //formata as variáveis antes de mandar pro back pois estão com nomes diferentes.
    async formatQuotationCostsAgro(payload) {
      let result = {
        numero_cotacao: payload.form.numero_cotacao,
        informacoes_adicionais: payload.form.textInput,
        custos: [],
        custos_cafezal: []
      };

      for (let i = 0; i < payload.form.quotationCosts.length; i++) {
        let quotationCost = payload.form.quotationCosts[i];

        result.custos.push({
          id: quotationCost.id,
          numero: quotationCost.numero,
          tipo_seguro_id: quotationCost.insuranceType.id,
          seguradora: quotationCost.insuranceCompany,
          area_segurada: quotationCost.insuredArea,
          tipo_reivindicacao_id: quotationCost.claimType.id,
          tipo_cobertura_id: quotationCost.coverage.id,
          importancia_segurada: quotationCost.insuredValue,
          producao_garantida: quotationCost.grantedProduction,
          custo_por_saca: quotationCost.costPerSac,
          custo_por_hectare: quotationCost.hectareCost,
          custo_total: quotationCost.total,
          comissao: quotationCost.comissao,
          subvencao_federal: quotationCost?.federalSubvention,
          subvencao_estadual: quotationCost?.stateSubvention,
          custo_segurado: quotationCost.insuredPrice,
          custo_produtor: quotationCost.farmerPrice,
          forma_pagamento_id: quotationCost.paymentForm.id
        });
      }

      for (let i = 0; i < payload.form.quotationCostsCafezal.length; i++) {
        let quotationCost = payload.form.quotationCostsCafezal[i];
        result.custos_cafezal.push({
          id: quotationCost.id,
          seguradora: quotationCost.seguradora,
          area_segurada: quotationCost.area_segurada,
          granizo: quotationCost.granizo,
          granizo_geada: quotationCost.granizo_geada,
          tipo_pos: quotationCost.tipo_pos,
          investimento: quotationCost.investimento,
          perda_producao_futura: quotationCost.perda_producao_futura,
          premio_segurado: quotationCost.premio_segurado,
          premio_total: quotationCost.premio_total,
          custo_total: quotationCost.total,
          comissao: quotationCost.comissao,
          subvencao_federal: quotationCost.subvencao_federal,
          subvencao_estadual: quotationCost.subvencao_estadual,
          tratamento_fitossanitario: quotationCost.tratamento_fitossanitario,
          valor_planta: quotationCost.valor_planta,
          forma_pagamento: { id: "5" } // fixo porque no cafezal é o limite definido pelo requisito para todos os custos
        });
      }

      return result;
    }
  }
};
